module.exports = __webpack_public_path__ + "img/icon_5_29.ae8ff8e1.png";